import { apiClient } from './api-client';
import type { Quiz, CreateQuizInput, UpdateQuizInput } from '../types/quiz';

export async function fetchQuizzes(): Promise<Quiz[]> {
  return apiClient<Quiz[]>('/admin/quizzes');
}

export async function fetchQuiz(quizId: string): Promise<Quiz> {
  return apiClient<Quiz>(`/admin/quizzes/${quizId}`);
}

export async function createQuiz(input: CreateQuizInput): Promise<Quiz> {
  return apiClient<Quiz>('/admin/quizzes', {
    method: 'POST',
    body: JSON.stringify(input),
  });
}

export async function updateQuiz(quizId: string, input: UpdateQuizInput): Promise<Quiz> {
  return apiClient<Quiz>(`/admin/quizzes/${quizId}`, {
    method: 'PUT',
    body: JSON.stringify(input),
  });
}

export async function deleteQuiz(quizId: string): Promise<{ id: string; archived: boolean }> {
  return apiClient<{ id: string; archived: boolean }>(`/admin/quizzes/${quizId}`, {
    method: 'DELETE',
  });
}

export async function publishQuiz(quizId: string): Promise<Quiz> {
  return apiClient<Quiz>(`/admin/quizzes/${quizId}/publish`, {
    method: 'POST',
  });
}

export async function archiveQuiz(quizId: string): Promise<Quiz> {
  return apiClient<Quiz>(`/admin/quizzes/${quizId}/archive`, {
    method: 'POST',
  });
}
